import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import {
  Stack,
  Button,
  Box,
  Grid,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Paper,
  CircularProgress,
  Popover,
  Typography,
  Divider,
  MenuItem,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  IconButton,
  Backdrop,
  Badge,
  Tabs,
  Tab,
  Chip
} from '@mui/material'
import client from '../common/client'
import AceEditor from 'react-ace'
import 'brace/ext/searchbox'
import 'ace-builds/src-noconflict/mode-java'
import 'ace-builds/src-noconflict/theme-github'
import toast, { Toaster } from 'react-hot-toast'
import BlockViewer from '../editor/BlockViewer'
import { ruleList } from '../editor/RuleStatic'
import IDERulePannel from './IDERulePannel'
import IDERuleList from './IDERuleList'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import CloseIcon from '@mui/icons-material/Close'

const ProgramBlock = props => {
  const [type, setType] = useState('')
  const [targetNode, setTargetNode] = useState('')
  const [hasTargetComponentRule, setHasTargetComponentRule] = useState(false)
  const [showRulePannel, setShowRulePannel] = useState(false)
  const [rulePannelTab, setRulePannelTab] = useState('new')
  const [sketchUdid, setSketchUdid] = React.useState('')
  const [rule, setRule] = React.useState(ruleList[0])
  const [ruleInstance, setRuleInstance] = React.useState(null)
  const [ruleInstanceList, setRuleInstanceList] = React.useState([])
  const [ruleInstanceShowList, setRuleInstanceShowList] = React.useState([])
  const [changeIndex, setChangeIndex] = React.useState(1)

  //   const [value, setValue] = useState('')
  //   const [modified, setModified] = useState(false)

  useEffect(() => {
    if (props.block_id) {
      client.request_get('/block/' + props.block_id).then(block => {
        // console.log('block', block)
        setSketchUdid(block.sketch_udid)
        client
          .request_get('/api/rule/list/' + props.block_id)
          .then(rule_list => {
            let targetComponentRule = rule_list.find(
              m => m.type == 'targetComponent'
            )

            setRuleInstanceList(rule_list)
            setHasTargetComponentRule(targetComponentRule ? true : false)
            if (targetComponentRule) setTargetNode(targetComponentRule.select1)
          })
      })

      updateRule()
    }
  }, [props.block_id])

  const handleChnage = (newValue, e) => {}

  const handleType = (event, newType) => {
    if (!sketchUdid || !newType) return
    setType(newType)

    let rule = ruleList.filter(m => m.type == newType)[0]
    setRule(rule)
    
    setRuleInstanceShowList(ruleInstanceList.filter(m => m.type == newType))
    setRuleInstance(null)
    setShowRulePannel(true)
  }

  const handleHelp = link => {
    if (link) window.open(link, '_blank')
  }

  const updateRule = () => {
    if (props.block_id) {
      client
        .request_get(`/api/rule/list/${props.block_id}`)
        .then(ruleInstanceList => {
          setRuleInstanceList(ruleInstanceList)
          if (type == 'targetComponent')
            setRuleInstanceShowList(ruleInstanceList)
          else
            setRuleInstanceShowList(
              ruleInstanceList.filter(m => m.type == type)
            )

          // console.log('updateRule end', ruleInstanceList.filter(m => m.type == type))
          let targetComponent = ruleInstanceList.filter(
            m => m.type == 'targetComponent'
          )
          if (targetComponent.length > 0) {
            setTargetNode(targetComponent[0].select1)
          }

          setChangeIndex(changeIndex + 1)
        })
    }
  }

  const tabRulePannel = tab => {
    setRulePannelTab(tab)
  }

  const handleEdit = (rule) => {
    setRuleInstance(rule)
    setRulePannelTab('new')
    setShowRulePannel(true)
  }

  const handleRuleChanged = (rule) => {

  }

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Toaster position='bottom-center' reverseOrder={false} />

      {/* 팝오버 */}
      {showRulePannel && (
        <Card
          sx={{
            width: '600px',
            height: '50vh',
            position: 'absolute',
            zIndex: 100,
            bottom: 0,
            // borderRadius: '30px',
            padding: '20px',
            marginLeft: '20px',
            // boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.05)',
            overflow: 'scroll'
          }}
        >
          <CardHeader
            title={
              <Box>
                {rule.name}
                <Chip
                  onClick={() => {
                    tabRulePannel('new')
                  }}
                  sx={{ cursor: 'pointer', marginLeft: '10px' }}
                  label='NEW'
                  color='primary'
                  variant={rulePannelTab == 'new' ? 'contained' : 'outlined'}
                  size='large'
                />

                <Chip
                  onClick={() => {
                    tabRulePannel('list')
                  }}
                  sx={{ cursor: 'pointer', marginLeft: '10px' }}
                  label='LIST'
                  color='primary'
                  variant={rulePannelTab == 'list' ? 'contained' : 'outlined'}
                  size='large'
                />
              </Box>
            }
            action={
              <IconButton color='secondary'>
                <CloseIcon
                  onClick={() => {
                    setShowRulePannel(false)
                  }}
                />
              </IconButton>
            }
          />
          <CardContent>
            {['new', 'edit'].includes(rulePannelTab) && (
              <IDERulePannel
                block_id={props.block_id}
                rule={rule}
                ruleInstance={ruleInstance}
                changed={updateRule}
                sketchUdid={sketchUdid}
                targetNode={targetNode}
              />
            )}
            {['list'].includes(rulePannelTab) && (
                <IDERuleList
                    id={props.block_id} list={ruleInstanceShowList} change={changeIndex} changed={updateRule} edit={handleEdit}
                />
            )}
          </CardContent>
          <CardActions></CardActions>
        </Card>
      )}

      <Stack direction='row' spacing={1} >

        <Box width={'100%'}>
          <BlockViewer
            block_id={props.block_id}
            change={handleChnage}
            clickable={true}
          />
        </Box>
        <Box>
          <IconButton color="primary">
            <CloseIcon onClick={(e) => {props.onClose()}}/>
          </IconButton>
        </Box>
        <Box>
          <ToggleButtonGroup
            orientation='vertical'
            value={type}
            exclusive
            onChange={handleType}
            sx={{
              width: '80px',
              height: '100%',
              maxHeight: 'calc(100vh - 50px)',
              overflow: 'scroll'
            }}
          >
            {hasTargetComponentRule &&
              ruleList.map(m => (
                <Tooltip
                  interactive
                  enterDelay={500}
                  title={
                    <Box>
                      {m.description}
                      <IconButton color='secondary'>
                        <HelpOutlineIcon
                          onClick={() => {
                            handleHelp(m.help)
                          }}
                        />
                      </IconButton>
                    </Box>
                  }
                >
                  <ToggleButton
                    size='small'
                    key={m.type}
                    value={m.type}
                    sx={{
                      fontSize: '11px',
                      justifyContent: 'flex-start',
                      textTransform: 'none'
                    }}
                  >
                    <Badge
                      badgeContent={
                        m.type == 'targetComponent'? 0 :
                        ruleInstanceList.filter(f => f.type == m.type).length
                      }
                      color='primary'
                    >
                      {m.icon()}
                    </Badge>
                    {m.name}
                  </ToggleButton>
                </Tooltip>
              ))}
          </ToggleButtonGroup>
        </Box>
      </Stack>
    </Box>
  )
}

export default ProgramBlock
